// Configuration for client-side conversation labels.
// Values match the backend `label` field on the communication record.

export type ConversationLabel =
    | "screening"
    | "onsite_interview"
    | "offer"
    | "hired"
    | "rejected";

// Fixed set of pickable labels (plus a "no label" option for clearing).
export const LABEL_OPTIONS: {value: ConversationLabel; label: string}[] = [
    {value: "screening", label: "Screening"},
    {value: "onsite_interview", label: "Gespräch"},
    {value: "offer", label: "Angebot"},
    {value: "hired", label: "Eingestellt"},
    {value: "rejected", label: "Abgelehnt"},
];

export interface LabelConfig {
    label: string;
    color: string;
    bg: string;
}

export const LABEL_CONFIG: Record<ConversationLabel, LabelConfig> = {
    screening: {label: "Screening", color: "#1677ff", bg: "#e6f4ff"},
    onsite_interview: {label: "Gespräch", color: "#722ed1", bg: "#f9f0ff"},
    offer: {label: "Angebot", color: "#fa8c16", bg: "#fff7e6"},
    hired: {label: "Eingestellt", color: "#52c41a", bg: "#f6ffed"},
    rejected: {label: "Abgelehnt", color: "#ff4d4f", bg: "#fff2f0"},
};

export const LABEL_TABS: {key: ConversationLabel | "all"; label: string}[] = [
    {key: "all", label: "Alle"},
    {key: "screening", label: "Screening"},
    {key: "onsite_interview", label: "Gespräch"},
    {key: "offer", label: "Angebot"},
    {key: "hired", label: "Eingestellt"},
    {key: "rejected", label: "Abgelehnt"},
];

export const getInitials = (name?: string): string => {
    if (!name) return "?";
    const parts = name.trim().split(/\s+/);
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};
